import { useGetAllCategories } from "modules/categories";

import { useGetProductsFilterMeta } from "../apis";

const useProductsFilter = () => {
  const { categories, isLoading: isCategoriesLoading } = useGetAllCategories();
  const { filterMeta, isFetching: isFilterMetaLoading } =
    useGetProductsFilterMeta();

  return { categories, filterMeta, isFilterMetaLoading, isCategoriesLoading };
};

export default useProductsFilter;
